module.exports = __webpack_public_path__ + "static/media/plus-unsafe.fc33b3b2.svg";